import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import Glide from "@glidejs/glide";

@ModuleName("RentalShopDetails")
export class RentalShopDetails implements AxInit {
    AxInit(init): void {

        const glide = new Glide('#rental__shopDetails-glider', {
            type: 'slider',
            perView: 1,
            rewind: true,
            bound: true,
            animationDuration: 300,
            classes: {
                activeSlide: 'glide__slide--active',
                disabledArrow: 'glide__arrow--disabled'
            },
            gap: 0
        });

        glide.mount();
    }
}